import { IOrderRemainingHoursReport } from '../types/orderRemainingHoursReport';
import OrderEnum from '../enumerables/order-enum';
import GeneralEnum from '../enumerables/general-enum';
import { getValFromEnum } from '../components/redux-form/utils/dropdown-values';

export const groupOrderRemainingToCsv = (data: IOrderRemainingHoursReport[]) => {
    //
    const groupData: any = [
        [
            'Order',
            'Order Name',
            'Order Type',
            'Case Number',
            'Student',
            'Service Type',
            'Recently used orders',
            'Status',
            'External rate',
            'Future Income',
            'Amount Of Remaining Hours',
            'Approximately Month Left',
        ],
    ];

    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);

    const OrderStatusValues = OrderEnum ? OrderEnum.getEnum('OrderStatus') : {};
    const orderStatuses: SelectObject[] = getValFromEnum(OrderStatusValues);

    data.forEach((it) => {
        const labelArr = [];
        if (it?.serviceType?.title) {
            labelArr.push(it.serviceType.title);
        }
        if (it?.serviceType?.cpt) {
            labelArr.push(`CPT: [${it.serviceType.cpt}]`);
        }
        const label = labelArr.join(', ');

        let valueOrderType: any = orderTypes.find((itp) => itp.value === it?.orderType);
        valueOrderType = valueOrderType ? valueOrderType.label : '';

        let orderStatusType: any = orderStatuses.find((itp) => itp.value === it?.status);
        orderStatusType = orderStatusType ? orderStatusType.label : '';

        const completedFilterValues: SelectObject[] = [
            {
                label: 'yes',
                value: 1,
            },
            {
                label: 'no',
                value: 2,
            },
        ];

        const valueCaseCompleted = completedFilterValues.find((its) => {
            return its.value == it.recentOrders;
        });

        groupData.push([
            it.id ? it.id : '',
            it.name ? it.name : '',
            valueOrderType ? valueOrderType : '',
            it.caseNumber ? it.caseNumber : '',
            it.student ? `${it.student.firstName} ${it.student.lastName}` : '',
            label,
           // it.recentOrders ? it.recentOrders : '',
            valueCaseCompleted ? valueCaseCompleted.label : '',
            orderStatusType ? orderStatusType : '',
            it.externalRate ? it.externalRate : '',
            it.futureIncome ? it.futureIncome : '',
            it.amountOfRemainingHours ? it.amountOfRemainingHours : '',
            it.monthLeftOfRemainingHours ? it.monthLeftOfRemainingHours : '',
        ]);
    });

    return groupData;
};
